import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetDocument,
  cleanUpDocument,
  cleanUpMessageDocument
} from 'state-managament/document.slice';

export default function useDocument(project) {
  const { error, success, isLoaded, data } = useSelector((state) => state.document);
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpDocument());
  const cleanUpMessage = () => dispatch(cleanUpMessageDocument());
  const getDocument = (args) => dispatch(fetchGetDocument(args));


  return {
    error,
    success,
    isLoaded,
    data,
    cleanUp,
    cleanUpMessage,
    getDocument,
  };

}
